//PDF解析地址
export const PDF_PATH = 'http://192.168.5.21:8012/onlinePreview'

//RabbitMQ
export const MQ_PROTOCOL = 'wss' //连接协议
// export const MQ_IP = '192.168.5.26' //ip
// export const MQ_IP = '120.24.22.17' //ip
export const MQ_IP = 'test-stomp.amdox.com.cn' //ip
// export const MQ_PORT = '15674' //端口
// export const MQ_PORT = '15674' //端口
export const MQ_ADDRESS = 'ws'
export const MQ_ACCOUNT = 'read' //账号
export const MQ_PASSWORD = 'read' //密码
// export const MQ_SUBSCRIPT = '/recycle_consumer_queue/recycle_consumer_routingkey.cus' //订阅
export const MQ_SUBSCRIPT = '/queue/recycle_consumer_queue' //订阅
export const MQ_LOOKBACK = '/queue/lookback_consumer_queue' //订阅


//直播视频页面弹幕聊天 WebSocket连接地址
export const WS_URL = 'https://test-yunkec.amdox.com.cn/websocket/gs-guide-websocket'
// export const WS_URL = 'http://192.168.5.26:13980/websocket/gs-guide-websocket'